import { render } from 'react-dom'
import { Comments } from '../../Comments/Comments'

document.addEventListener('DOMContentLoaded', () => {
  render(<Comments />, document.getElementById('comments'))
})
